// Find a node in a tree with this path
const findInTree = (treeNodes, path) => {
  for (const node of treeNodes) {
    if (node.path === path) {
      return node
    }

    if (node.children.length > 0) {
      const nodeChild = findInTree(node.children, path)
      if (nodeChild) return nodeChild
    }
  }

  return null
}

export default findInTree
